import { createHttpClient } from '../../../api/http';
import { serviceUrls } from '../../../config/serviceUrls';

const COMMS_PREFIX = '/email';
const gatewayClient = createHttpClient(serviceUrls.gateway);

export const listEmailConfigs = async (tenant_id?: string) => {
  const response = await gatewayClient.get(`${COMMS_PREFIX}/configs`, {
    params: tenant_id ? { tenant_id } : {},
  });
  return response.data;
};

export const createEmailConfig = async (payload: any) => {
  const response = await gatewayClient.post(`${COMMS_PREFIX}/configs`, payload);
  return response.data;
};

export const updateEmailConfig = async (id: string, payload: any) => {
  const response = await gatewayClient.put(`${COMMS_PREFIX}/configs/${id}`, payload);
  return response.data;
};

export const listEmailTemplates = async (tenant_id?: string) => {
  const response = await gatewayClient.get(`${COMMS_PREFIX}/templates`, {
    params: tenant_id ? { tenant_id } : {},
  });
  return response.data;
};

export const createEmailTemplate = async (payload: any) => {
  const response = await gatewayClient.post(`${COMMS_PREFIX}/templates`, payload);
  return response.data;
};

export const updateEmailTemplate = async (id: string, payload: any) => {
  const response = await gatewayClient.put(`${COMMS_PREFIX}/templates/${id}`, payload);
  return response.data;
};


